export function getTabSetInitialState() {
    return {};
}
